export default __webpack_public_path__ + "static/media/720GreenCityBlock.4af37869.mp4";